/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconArrowLeft from '@telus-uds/palette-allium/build/rn/icons/ArrowLeft'
import PaletteIconArrowRight from '@telus-uds/palette-allium/build/rn/icons/ArrowRight'
const theme = {
  appearances: {
    alternative: { type: 'variant', values: [ true ] },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inverse: { type: 'variant', values: [ true ] },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    quiet: {
      description: 'When it is true, it does not show the decoration',
      type: 'state',
      values: [ true, false ]
    },
    size: {
      description: 'Sets the size of the text and icon; these variants are shared with ChevronLink',
      type: 'variant',
      values: [ 'large', 'small', 'micro' ]
    },
    style: {
      type: 'variant',
      values: [ 'inline', 'subtle', 'feature', 'danger', 'inverse' ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: { color: '#1f5c09', iconDisplace: 4 }
    },
    { if: { pressed: true }, tokens: { color: '#163e06' } },
    { if: { alternative: true }, tokens: { color: '#414547' } },
    {
      if: { alternative: true, hover: true },
      tokens: { color: '#2c2e30' }
    },
    {
      if: { alternative: true, pressed: true },
      tokens: { color: '#2c2e30' }
    },
    { if: { inverse: true }, tokens: { color: '#ffffff' } },
    {
      if: { hover: true, inverse: true },
      tokens: { color: '#f4f4f7' }
    },
    {
      if: { inverse: true, pressed: true },
      tokens: { color: '#e3e6e8' }
    },
    {
      if: { size: 'large' },
      tokens: { blockLineHeight: 1.6, fontSize: 20, iconSize: 20 }
    },
    {
      if: { size: 'small' },
      tokens: { blockLineHeight: 1.42857142857, fontSize: 14, iconSize: 16 }
    },
    {
      if: { size: 'micro' },
      tokens: { blockLineHeight: 1.33333333333, fontSize: 12, iconSize: 16 }
    },
    { if: { focus: true }, tokens: { outerBorderColor: '#2b8000' } },
    {
      if: { focus: true, pressed: true },
      tokens: { outerBorderColor: '#163e06' }
    },
    {
      if: { focus: true, inverse: true },
      tokens: { outerBorderColor: '#ffffff' }
    },
    {
      if: { alternative: true, focus: true },
      tokens: { color: '#414547', outerBorderColor: '#414547' }
    },
    {
      if: { focus: true, quiet: true },
      tokens: { color: '#2b8000', textLine: 'underline' }
    },
    { if: { style: 'inline' }, tokens: { color: '#414547' } },
    {
      if: { focus: true, style: 'inline' },
      tokens: { color: '#414547', outerBorderColor: '#414547' }
    },
    {
      if: { hover: true, style: 'inline' },
      tokens: { color: '#2c2e30', textLine: 'none' }
    },
    {
      if: { pressed: true, style: 'inline' },
      tokens: { color: '#2c2e30', textLine: 'none' }
    },
    {
      if: { focus: true, pressed: true, style: 'inline' },
      tokens: { outerBorderColor: '#2c2e30' }
    },
    { if: { style: 'subtle' }, tokens: { color: '#676e73' } },
    {
      if: { focus: true, style: 'subtle' },
      tokens: { color: '#676e73', outerBorderColor: '#676e73' }
    },
    {
      if: { hover: true, style: 'subtle' },
      tokens: { color: '#2c2e30', textLine: 'none' }
    },
    {
      if: { pressed: true, style: 'subtle' },
      tokens: { color: '#2c2e30', textLine: 'none' }
    },
    {
      if: { focus: true, pressed: true, style: 'subtle' },
      tokens: { outerBorderColor: '#2c2e30' }
    },
    { if: { style: 'feature' }, tokens: { color: '#2b8000' } },
    {
      if: { focus: true, style: 'feature' },
      tokens: { color: '#2b8000', outerBorderColor: '#2b8000' }
    },
    {
      if: { hover: true, style: 'feature' },
      tokens: { color: '#1f5c09', textLine: 'none' }
    },
    {
      if: { pressed: true, style: 'feature' },
      tokens: { color: '#163e06', textLine: 'none' }
    },
    {
      if: { focus: true, pressed: true, style: 'feature' },
      tokens: { outerBorderColor: '#163e06' }
    },
    { if: { style: 'danger' }, tokens: { color: '#c12335' } },
    {
      if: { focus: true, style: 'danger' },
      tokens: { color: '#c12335', outerBorderColor: '#c12335' }
    },
    {
      if: { hover: true, style: 'danger' },
      tokens: { color: '#560c0c', textLine: 'none' }
    },
    {
      if: { pressed: true, style: 'danger' },
      tokens: { color: '#2c2e30', textLine: 'none' }
    },
    {
      if: { focus: true, pressed: true, style: 'danger' },
      tokens: { outerBorderColor: '#2c2e30' }
    },
    { if: { style: 'inverse' }, tokens: { color: '#ffffff' } },
    {
      if: { focus: true, style: 'inverse' },
      tokens: { color: '#ffffff', outerBorderColor: '#ffffff' }
    },
    {
      if: { hover: true, style: 'inverse' },
      tokens: { color: '#f4f4f7', textLine: 'none' }
    },
    {
      if: { pressed: true, style: 'inverse' },
      tokens: { color: '#b2b9bf', textLine: 'none' }
    },
    {
      if: { focus: true, pressed: true, style: 'inverse' },
      tokens: { outerBorderColor: '#b2b9bf' }
    },
    {
      if: { quiet: true, style: 'inline' },
      tokens: { color: '#414547', textLine: 'none' }
    },
    {
      if: { focus: true, quiet: true, style: 'inline' },
      tokens: {
        color: '#414547',
        outerBorderColor: '#414547',
        textLine: 'underline'
      }
    },
    {
      if: { hover: true, quiet: true, style: 'inline' },
      tokens: { color: '#2c2e30', textLine: 'underline' }
    },
    {
      if: { pressed: true, quiet: true, style: 'inline' },
      tokens: { color: '#2c2e30' }
    },
    {
      if: { focus: true, pressed: true, quiet: true, style: 'inline' },
      tokens: { outerBorderColor: '#2c2e30' }
    },
    {
      if: { quiet: true, style: 'subtle' },
      tokens: { color: '#676e73', textLine: 'none' }
    },
    {
      if: { focus: true, quiet: true, style: 'subtle' },
      tokens: {
        color: '#676e73',
        outerBorderColor: '#676e73',
        textLine: 'underline'
      }
    },
    {
      if: { hover: true, quiet: true, style: 'subtle' },
      tokens: { color: '#2c2e30', textLine: 'underline' }
    },
    {
      if: { pressed: true, quiet: true, style: 'subtle' },
      tokens: { color: '#2c2e30' }
    },
    {
      if: { focus: true, pressed: true, quiet: true, style: 'subtle' },
      tokens: { outerBorderColor: '#2c2e30' }
    },
    {
      if: { quiet: true, style: 'feature' },
      tokens: { color: '#2b8000', textLine: 'none' }
    },
    {
      if: { focus: true, quiet: true, style: 'feature' },
      tokens: {
        color: '#2b8000',
        outerBorderColor: '#2b8000',
        textLine: 'underline'
      }
    },
    {
      if: { hover: true, quiet: true, style: 'feature' },
      tokens: { color: '#1f5c09', textLine: 'underline' }
    },
    {
      if: { pressed: true, quiet: true, style: 'feature' },
      tokens: { color: '#163e06' }
    },
    {
      if: { focus: true, pressed: true, quiet: true, style: 'feature' },
      tokens: { outerBorderColor: '#163e06' }
    },
    {
      if: { quiet: true, style: 'danger' },
      tokens: { color: '#c12335', textLine: 'none' }
    },
    {
      if: { focus: true, quiet: true, style: 'danger' },
      tokens: {
        color: '#c12335',
        outerBorderColor: '#c12335',
        textLine: 'underline'
      }
    },
    {
      if: { hover: true, quiet: true, style: 'danger' },
      tokens: { color: '#560c0c', textLine: 'underline' }
    },
    {
      if: { pressed: true, quiet: true, style: 'danger' },
      tokens: { color: '#2c2e30' }
    },
    {
      if: { focus: true, pressed: true, quiet: true, style: 'danger' },
      tokens: { outerBorderColor: '#2c2e30' }
    },
    {
      if: { quiet: true, style: 'inverse' },
      tokens: { color: '#ffffff', textLine: 'none' }
    },
    {
      if: { focus: true, quiet: true, style: 'inverse' },
      tokens: {
        color: '#ffffff',
        outerBorderColor: '#ffffff',
        textLine: 'underline'
      }
    },
    {
      if: { hover: true, quiet: true, style: 'inverse' },
      tokens: { color: '#f4f4f7', textLine: 'underline' }
    },
    {
      if: { pressed: true, quiet: true, style: 'inverse' },
      tokens: { color: '#b2b9bf' }
    },
    {
      if: { focus: true, pressed: true, quiet: true, style: 'inverse' },
      tokens: { outerBorderColor: '#b2b9bf' }
    }
  ],
  tokens: {
    blockLineHeight: 1.5,
    color: '#2b8000',
    fontSize: 16,
    iconDisplace: 0,
    iconSize: 16,
    iconSpace: 1,
    leftIcon: PaletteIconArrowLeft,
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    rightIcon: PaletteIconArrowRight,
    textLine: 'none'
  }
}
export default theme
